import { createApp } from 'vue'
import { loadTranslations } from '@/js/global/vue-i18n'
import Home from '@/components/home/views/Home.vue'

const app = createApp(Home)

loadTranslations(app).then(() => {
    app.mount('#home-vue')
})
